<template>
    <div v-if="item">
        <question :text="$t(item.text)" />
        <b-row class="d-flex justify-content-center" :style="injectCSSVariable()">
            <b-col cols="12" md="8" lg="8">
                <draggable
                    class="ranked-order-choice__choice w-100"
                    :list="list"
                    @start="startDrag"
                    @end="endDrag"
                    @update="update"
                    :forceFallback="true"
                    handle=".ranked-order-choice__handle"
                    ghost-class="ranked-order-choice__choice--ghost"
                >
                    <b-button
                        block
                        class="ranked-order-choice__button"
                        :variant="`outline-${colorVariant}`"
                        v-for="choice in list"
                        :key="choice.order"
                    >
                        <div class="ranked-order-choice__button-content d-flex justify-content-between align-items-center">
                            <div class="ranked-order-choice__rank">
                                {{ choice.displayRank }}
                            </div>
                            <div class="ranked-order-choice__text text-left w-100 pl-2 pl-sm-4 pl-md-5">
                                {{ $t(choice.text) }}
                            </div>
                            <div class="ranked-order-choice__handle d-flex align-items-center">
                                <img src="@/assets/ui/drag.svg" />
                            </div>
                        </div>
                    </b-button>
                </draggable>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import question from '@/components/ui/question';
import draggable from 'vuedraggable';
import colorvariantMixin from '@/components/mixins/colorVariantMixin'
import { STACK_SORT } from '@/constants/itemTypes'
import { STACK_CONFIG } from '@/constants/items'

export default {
    name: 'rankedOrderItem',
    components: {
        question,
        draggable,
    },
    mixins: [colorvariantMixin],
    props: {
        item: {
            type: Object,
        },
        itemProperties: {
            type: Object
        }
    },
    data() {
        return {
            dragging: false,
            list: [],
        }
    },
    methods: {
        startDrag() {
            this.dragging = true
        },
        endDrag() {
            this.dragging = false
        },
        update() {
            // the result order is reversed as it was in the previous interaction system
            // the top most item in the list gets the highest number of "points"

            // item of type STACK_SORT will be displayed as ranked order choice item but its result will be
            // put in "bins" according to configuration property (a string e.g. 1_2_3_2_1)
            if(this.item.itemType === STACK_SORT) {
                const config = this.itemProperties.getProperty(STACK_CONFIG)

                if(config) {
                    const stacks = config.split('_').map(number => parseInt(number))
                    const answer = []

                    // count for displayRank (only used for displaying position) because we splice the result array
                    let dis = 0;
                    stacks.map((stackNumber, stackIndex) => {
                        return this.list.splice(0, stackNumber)
                            .map((choice, index) => {
                                dis += 1
                                answer.push({
                                    ...choice,
                                    choiceNumber: choice.choiceNumber,
                                    result: stacks.length - stackIndex,
                                    displayRank: dis
                                })
                            })
                    })
                    this.list = answer
                }

            } else {
                this.list = this.list.map((choice, index) => ({
                    ...choice,
                    result: this.list.length - index,
                    displayRank: index + 1
                }))
            }

            this.$emit('answer', this.list.map(choice => ({
                choice: choice.choiceNumber,
                result: choice.result
            })))
        },
        injectCSSVariable() {
            return { '--base-color': this.baseColor };
        }
    },
    mounted() {
        this.list = this.item.choices.map(({ name, text, order, result }, i) => {
            return {
                name,
                text,
                order,
                // choice value is returned by backend as "result", we will use it as choice number and assign a result according to order or stacksort logic
                choiceNumber: result,
                displayRank: i + 1
            }
        })
    }
}
</script>
<style lang="scss">
    .ranked-order-choice__button {
        padding: 0;
        min-height: 3rem;
        overflow: hidden;
    }

    .ranked-order-choice__choice {
        cursor: pointer;
        margin-bottom: 10px;
    }

    .ranked-order-choice__text {
        margin-left: 0.2rem;
        font-size: 0.9rem;
        @media screen and (min-width: 450px) {
            font-size: 1rem;
        }
    }

    .ranked-order-choice__rank {
        font-weight: 600;
        padding-left: 0.75rem;
    }

    .ranked-order-choice__handle {
        padding-right: 0.8rem;
        padding-left: 2.75rem;
        min-height: 3rem;
        background: rgba(100, 100, 100, 0.1);

        img {
            pointer-events: none;
        }
    }

    .ranked-order-choice__choice--ghost {
        color: white !important;
        background-color: var(--base-color) !important;
    }
</style>
